{
    "title": "Complaints",
    "description": "Every complaint the Bank has received, on one queue.",
    "workspace_title": "Complaint workspace",
    "search_placeholder": "Search by reference, subject or wording…",
    "empty_title": "No complaints match this view",
    "empty_description": "Try a different saved view, or clear the search and filters.",
    "reference": "Reference",
    "subject": "Subject",
    "customer": "Customer",
    "category": "Category",
    "status": "Status",
    "priority": "Priority",
    "source": "Source",
    "channel": "Channel",
    "outcome": "Outcome",
    "assignee": "Assigned to",
    "team": "Team",
    "branch": "Branch",
    "product": "Product",
    "age": "Age",
    "logged": "Logged",
    "resolved": "Resolved",
    "closed": "Closed",
    "unassigned": "Unassigned",
    "risk": "Risk",
    "views": {
        "label": "Saved views",
        "mine": "Assigned to me",
        "unassigned": "Unassigned",
        "breaching_soon": "Breaching soon",
        "breached": "Breached",
        "escalated": "Escalated",
        "awaiting_customer": "Awaiting customer",
        "high_risk": "High risk",
        "open": "All open"
    },
    "sla": {
        "label": "Service level",
        "due": "Due {{when}}",
        "overdue_by": "Overdue by {{duration}}",
        "remaining": "{{duration}} left",
        "policy": "Policy",
        "target": "{{count}} working day target",
        "target_plural": "{{count}} working day target",
        "first_response": "First response",
        "first_response_met": "Met",
        "first_response_missed": "Missed",
        "paused_note": "The clock is paused while the Bank is waiting on the customer.",
        "paused_for": "Paused for {{duration}} so far"
    },
    "thread": {
        "title": "Conversation",
        "internal_note": "Internal note",
        "internal_badge": "Internal",
        "from_customer": "From the customer",
        "to_customer": "To the customer",
        "ai_drafted": "Drafted with AI assistance",
        "ai_edited": "Edited before sending",
        "empty": "Nothing has been added to this complaint yet.",
        "note_placeholder": "A note only colleagues will see…",
        "reply_placeholder": "Your reply to the customer…",
        "add_note": "Add note",
        "send_reply": "Send reply",
        "note_help": "Internal notes are never shown to the customer.",
        "reply_help": "This is sent to the customer and appears on their status page."
    },
    "attachments": {
        "title": "Attachments",
        "empty": "No files attached.",
        "pending_scan": "Awaiting virus scan",
        "unsafe": "Blocked by the virus scanner",
        "from_customer": "Sent by the customer"
    },
    "history": {
        "title": "History",
        "automated": "Automatic",
        "empty": "No activity recorded yet."
    },
    "actions": {
        "log": "Log a complaint",
        "change_status": "Change status",
        "assign": "Assign",
        "reassign": "Reassign",
        "unassign": "Return to the team queue",
        "resolve": "Resolve",
        "close": "Close",
        "reopen": "Reopen",
        "open_customer": "Open customer record",
        "reason": "Reason",
        "reason_optional": "Reason (optional)",
        "reason_placeholder": "Why is this being done?",
        "confirm": "Confirm",
        "cancel": "Cancel"
    },
    "resolve_dialog": {
        "title": "Resolve complaint {{reference}}",
        "description": "The summary is shown to the customer on their status page and reported in the Central Bank return, so write it for them rather than for the file.",
        "outcome": "Outcome",
        "summary": "Resolution summary",
        "summary_placeholder": "What was found, and what the Bank did about it…",
        "compensation": "Compensation (OMR)",
        "compensation_help": "Leave blank if none was paid."
    },
    "reopen_dialog": {
        "title": "Reopen complaint {{reference}}",
        "description": "The complaint keeps its reference and its history. Reopening is counted and reported."
    },
    "customer_panel": {
        "title": "Customer",
        "vip": "VIP",
        "requires_assistance": "Needs assistance",
        "complaints_total": "{{count}} complaint on record",
        "complaints_total_plural": "{{count}} complaints on record",
        "open_now": "{{count}} still open",
        "prefers": "Prefers {{channel}}",
        "language": "Writes in {{language}}"
    },
    "outcomes": {
        "upheld": "Upheld",
        "partially_upheld": "Partially upheld",
        "not_upheld": "Not upheld",
        "withdrawn": "Withdrawn",
        "duplicate": "Duplicate",
        "out_of_scope": "Out of scope"
    },
    "ai": {
        "not_analysed": "Not analysed",
        "confidence": "{{percent}}% confidence",
        "overridden": "Category corrected by an officer",
        "provenance": "Suggested by {{model}}"
    },
    "public": {
        "title": "Track your complaint",
        "description": "Enter the reference the Bank gave you. We will send a code to the mobile number on your record.",
        "reference_label": "Complaint reference",
        "reference_placeholder": "CMP-2026-000000",
        "request_code": "Send code",
        "code_label": "Verification code",
        "code_help": "Sent to {{destination}}. It expires in {{minutes}} minutes.",
        "code_help_generic": "If the reference is valid, a code has been sent to the mobile number on the record.",
        "verify": "View status",
        "resend": "Send another code",
        "back": "Use a different reference",
        "submitted": "Submitted",
        "expected": "Expected by",
        "resolution": "What the Bank did",
        "updates": "Updates",
        "no_updates": "There are no updates to show yet.",
        "confirm_title": "Did this resolve your complaint?",
        "confirm_description": "Telling us either way helps. If it did not, the complaint goes straight back to the team that handled it.",
        "confirm_yes": "Yes, this is resolved",
        "confirm_no": "No, reopen it",
        "reopen_reason_label": "What is still wrong?",
        "reopen_reason_placeholder": "Tell us what has not been put right…",
        "reopen_submit": "Reopen my complaint",
        "window_note": "You can respond until {{date}}.",
        "confirmed": "Thank you. Your complaint has been closed.",
        "reopened": "Your complaint has been reopened and sent back to our team."
    },
    "report": {
        "title": "Central Bank return",
        "description": "Complaint volumes, resolution times and outcomes for the reporting period.",
        "period": "Period",
        "generated": "Generated {{when}}",
        "total_received": "Received",
        "resolved": "Resolved",
        "still_open": "Still open",
        "reopened": "Reopened",
        "escalated": "Escalated",
        "by_category": "By regulatory category",
        "by_product": "By product",
        "by_channel": "By channel",
        "by_governorate": "By governorate",
        "by_branch": "By branch",
        "ageing": "Ageing",
        "resolution_times": "Resolution times",
        "outcomes": "Outcomes",
        "compensation": "Compensation",
        "business_hours_note": "Resolution times are measured in working hours against the Bank's calendar, not elapsed time.",
        "cohort_note": "Complaints are counted in the period they were received, so resolving late cannot move one out of a bad month.",
        "download": "Download CSV"
    },
    "toast": {
        "created": "Complaint {{reference}} logged.",
        "status_updated": "Status updated.",
        "assigned": "Complaint assigned.",
        "resolved": "Complaint resolved.",
        "closed": "Complaint closed.",
        "reopened": "Complaint reopened.",
        "note_added": "Note added.",
        "reply_sent": "Reply sent."
    },
    "config": {
        "title": "Complaint configuration",
        "description": "Routing rules, service level targets, categories and the working calendar.",
        "routing": "Routing rules",
        "sla": "Service levels",
        "categories": "Categories",
        "calendar": "Working calendar",
        "routing_note": "Rules are evaluated in order and the first match wins. A rule with no matches is either unreachable or wrong.",
        "sla_note": "Changing a target affects complaints logged from now on. Complaints already open keep the deadline they were given.",
        "match_all": "All conditions must hold",
        "match_any": "Any condition may hold",
        "matches": "{{count}} match",
        "matches_plural": "{{count}} matches",
        "stops": "Stops here",
        "rule_active": "Rule active",
        "move_up": "Move earlier",
        "move_down": "Move later",
        "default_policy": "Default",
        "first_response_hours": "First response (hours)",
        "resolution_hours": "Resolution (hours)",
        "closed": "Closed",
        "shortened": "Shortened hours",
        "exceptions": "Holidays and special hours",
        "rule_saved": "Routing rule saved.",
        "rules_reordered": "Rule order saved.",
        "policy_saved": "SLA policy saved."
    }
}
